import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Body from "./Body";
import { BsFillPersonFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { sendEmailVerification  } from "firebase/auth";
import { toast } from "react-toastify";
import { auth } from "./FireBaseConfig";

const ForgotPass = () => {
  let navigate = useNavigate();
  const [data, setData] = useState({
    VariEmail: "",
  });

  const { VariEmail } = data;

  const valuesChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const saveData = async (e) => {
    e.preventDefault();
    if (VariEmail !== "") {
      try {
        let user = await sendEmailVerification (auth, { email: VariEmail });
        console.log(user);

        navigate("/");
      } catch (error) {
        if (error.code)
          return toast.error(error.code, {
            position: "top-center",
          });
      }
    } else if (VariEmail == "") {
      toast.error("Please Enter Feild!!");
    }
  };

  return (
    <>
      <Navbar />
      <div className="main-containerr bgclr">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-7">
              <Body />
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-5">
              <div className="main-form mt-5">
                <div>
                  <div className="Info text-white">
                    <h3 className=" text-white mb-3">RAFFLE MANIA</h3>
                    <p>Forgot Password</p>
                    <p className="mt-5">
                      Please enter your email address to reset your password! A
                      message with code will be sent to an authorized email to
                      reaset the password.
                    </p>
                    <form className="mt-3 mb-4 formInputs">
                      <label for="pwd">EMAIL</label>
                      <div className="form-group d-flex">
                        <input
                          type="email"
                          className="forgotInput"
                          placeholder="Example@gmail.com"
                          id="pwd"
                          value={VariEmail}
                          name="VariEmail"
                          onChange={valuesChange}
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <BsFillPersonFill />
                          </span>
                        </div>
                      </div>
                    </form>

                    <div className="mt-3 btnDiv3 p-2 ">
                      <button
                        className="btn  w-100 mb-1 bg-white"
                        onClick={saveData}
                      >
                        Varification Code
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ForgotPass;
